import { z } from 'zod';

/**
 * Validation schema for the Basic Info step.
 */
export const basicInfoStepSchema = z.object({
  name: z
    .string()
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .max(100, 'El nombre no puede superar los 100 caracteres'),
  description: z
    .string()
    .min(10, 'La descripción debe tener al menos 10 caracteres'),
  prizes: z
    .string()
    .min(5, 'Debes describir los premios del torneo'),
  bannerUrl: z.string().optional(),
});

export type BasicInfoStepData = z.infer<typeof basicInfoStepSchema>;
